import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useFormContext } from "react-hook-form"
import { ComboboxFormField, ControllerHF, InputField } from "components"

export const SearchSection = props => {
  const { t } = useTranslation()

  const { control, setValue } = useFormContext()

  const leftAccessory = () => (
    <div className={"form-left-accessory"}>
      <i className={"mdi mdi-magnify font-size-16"} />
    </div>
  )

  const { isAddToGroupState, isEditGroupState } = props.modelPanelState

  useEffect(() => {
    //Trigger to remove group from select after removing group
    if (!props.isGroupSelected) {
      setValue("group", null)
    }
  }, [props.isGroupSelected])

  return (
    <>
      <ControllerHF
        name={"keywords"}
        control={control}
        component={InputField}
        label={null}
        placeholder={t("start_typing_models")}
        leftAccessory={leftAccessory()}
        autoComplete="off"
      />

      <ControllerHF
        name={"residence"}
        control={control}
        component={ComboboxFormField}
        id={"residence"}
        label={null}
        placeholder={t("country")}
        options={props.countryOptions}
        getOptionLabel={option => `${option.name}`}
        getOptionValue={option => option.id}
        normalize={option => (option ? option.id : null)}
        isDetermineValue
        selectProps={{
          isClearable: true,
        }}
      />
      <ControllerHF
        name={"group"}
        control={control}
        component={ComboboxFormField}
        id={"group"}
        disabled={isAddToGroupState || isEditGroupState}
        placeholder={t("group")}
        options={props.groupsOptions}
        getOptionLabel={option => `${option.name} (${option.type})`}
        getOptionValue={option => option.id}
        normalize={option => (option ? option.id : null)}
        isDetermineValue
        selectProps={{
          isClearable: true,
        }}
      />

      <ControllerHF
        name={"birthdayplace"}
        control={control}
        component={InputField}
        label={null}
        placeholder={t("city")}
        leftAccessory={leftAccessory()}
        autoComplete="off"
      />
    </>
  )
}

SearchSection.propTypes = {
  countryOptions: PropTypes.array,
  groupsOptions: PropTypes.array,
  modelPanelState: PropTypes.object,
  isGroupSelected: PropTypes.bool,
}
